/**
 * @generated SignedSource<<adba9d5e06ae27caeb16c778c76c9b44>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedPersonalizedSearchItems_buyPageItemRecommendations$data = {
  readonly personalizationSearchItems: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_item">;
  } | null> | null;
  readonly " $fragmentType": "BuySharedPersonalizedSearchItems_buyPageItemRecommendations";
};
export type BuySharedPersonalizedSearchItems_buyPageItemRecommendations$key = {
  readonly " $data"?: BuySharedPersonalizedSearchItems_buyPageItemRecommendations$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_buyPageItemRecommendations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedPersonalizedSearchItems_buyPageItemRecommendations",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 28
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "personalizationSearchItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRelatedItemsSection_item"
        }
      ],
      "storageKey": "personalizationSearchItems(first:28)"
    }
  ],
  "type": "BuyPageItemRecommendations",
  "abstractKey": null
};

(node as any).hash = "0baa9643c958ac346855c61b6c56751a";

export default node;
